"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var Validation_1 = __importDefault(require("../Validation"));
var numberHelpers_1 = require("../../helpers/numberHelpers");
var FormComponentFields_1 = __importDefault(require("./FormComponentFields"));
var PostingMortgage_1 = require("../../constants/PostingMortgage");
var FormInputLabel_1 = __importDefault(require("./FormInputLabel"));
var GeneralSettings_1 = require("../../constants/GeneralSettings");
var PostViewContentTypes_1 = require("../../constants/PostViewContentTypes");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var computed = {
    sqm_price: {
        deps: ['price', 'area'],
        fn: function (context) {
            if (!context.price || !context.area) {
                return 0;
            }
            return numberHelpers_1.numberPrecision(context.price / context.area);
        },
    },
};
var FormComponent = function (_a) {
    var _b;
    var field = _a.field, fieldName = _a.fieldName, order = _a.order, section = _a.section, formikProps = _a.formikProps, onMediaUpload = _a.onMediaUpload, onSingleMediaUpload = _a.onSingleMediaUpload, onSingleMediaRemove = _a.onSingleMediaRemove, removeParentEntityMedia = _a.removeParentEntityMedia, removeEntityMedia = _a.removeEntityMedia, onMediaReorder = _a.onMediaReorder, index = _a.index, disabled = _a.disabled, mortgageId = _a.mortgageId, addRemovedMortgageId = _a.addRemovedMortgageId, isDisableWhenRental = _a.isDisableWhenRental;
    var label = field.label, conditionalLabel = field.conditionalLabel;
    react_1.useEffect(function () {
        if (section === PostViewContentTypes_1.SECTION_TYPES.APARTMENT_INFO &&
            (formikProps.values.deal === GeneralSettings_1.DEAL_TYPES.SELL ||
                formikProps.values.initial_info.property_type ===
                    GeneralSettings_1.PROPERTY_TYPES.COMMERCIAL)) {
            formikProps.setFieldValue("apartment_info[" + index + "].animals", []);
        }
    }, [
        formikProps.values.deal,
        formikProps.values.initial_info.property_type,
    ]);
    var extractValue = function (name) {
        return extractValueWithField(section, name || fieldName, index);
    };
    var extractContext = function (section, index) {
        var s = formikProps.values[section];
        return index === undefined ? s : s[index];
    };
    var extractValueWithField = function (section, fieldName, index) {
        var s = extractContext(section, index);
        return s[fieldName];
    };
    var extractPath = function () {
        return extractPathWithField(section, fieldName, index);
    };
    var extractPathWithField = function (section, fieldName, index) {
        return index === undefined
            ? section + "." + fieldName
            : section + "[" + index + "]." + fieldName;
    };
    // We want to run the callback only for fields that ara in dependency
    // list of other fields
    var isInDependencies = react_1.useMemo(function () { return lodash_1.default.some(computed, function (value) { return lodash_1.default.includes(value.deps, fieldName); }); }, []);
    var cb = isInDependencies
        ? function (newValue) {
            lodash_1.default.forEach(computed, function (value, key) {
                var _a;
                if (lodash_1.default.includes(value.deps, fieldName)) {
                    var context = extractContext(section, index);
                    formikProps.setFieldValue(extractPathWithField(section, key, index), value.fn(__assign(__assign({}, context), (_a = {}, _a[fieldName] = newValue, _a))));
                }
            });
        }
        : undefined;
    var getRequiredMortgageFields = function () {
        var _a;
        return (PostingMortgage_1.RequiredMortgageFields.includes(field.label) &&
            ((_a = formikProps.values.mortgage[String(index)].name) === null || _a === void 0 ? void 0 : _a.length));
    };
    var getRequiredField = function () {
        var _a;
        return (field.isRequired ||
            getRequiredMortgageFields() ||
            ((_a = field.requiredDealScope) === null || _a === void 0 ? void 0 : _a.includes(formikProps.values.deal)));
    };
    return (react_1.default.createElement("div", { className: classnames_1.default('column', field.className ? styles_module_scss_1.default[field.className] : null, (_b = {},
            _b[field.width + " wide"] = field.width,
            _b)) },
        react_1.default.createElement("div", { className: classnames_1.default('field', {
                required: getRequiredField(),
            }) },
            !field.hideLabel && (react_1.default.createElement(FormInputLabel_1.default, { label: label, order: order, headerLabel: field.headerLabel, fieldName: fieldName, conditionalLabel: conditionalLabel, propertyType: formikProps.values.initial_info.property_type })),
            react_1.default.createElement(Validation_1.default, { name: extractPath(), formikProps: formikProps },
                react_1.default.createElement(FormComponentFields_1.default, { extractPath: extractPath, extractValue: extractValue, cb: cb, field: field, fieldName: fieldName, formikProps: formikProps, onMediaUpload: onMediaUpload, onSingleMediaUpload: onSingleMediaUpload, onSingleMediaRemove: onSingleMediaRemove, removeParentEntityMedia: removeParentEntityMedia, removeEntityMedia: removeEntityMedia, onMediaReorder: onMediaReorder, disabled: disabled, isDisableWhenRental: isDisableWhenRental, index: index, mortgageId: mortgageId, addRemovedMortgageId: addRemovedMortgageId })))));
};
exports.default = FormComponent;
